import { useUIStore } from '@/store/uiStore';
import OnboardingChecklist from '@/components/onboarding/OnboardingChecklist.vue';
import { onboardingService } from '@/services/onboardingService';

let activeChecklistModalId = null;

/**
 * Open the post-intake checklist modal.
 */
export function openOnboardingChecklist() {
  const uiStore = useUIStore();
  if (activeChecklistModalId) return activeChecklistModalId;

  activeChecklistModalId = uiStore.addModal(OnboardingChecklist, {
    title: '',
    size: 'lg',
    onClose: () => {
      if (activeChecklistModalId) {
        uiStore.closeModal(activeChecklistModalId);
        activeChecklistModalId = null;
      }
    },
  });

  return activeChecklistModalId;
}

/**
 * Open the checklist modal when the org still needs it and it was not dismissed.
 */
export async function showOnboardingChecklistIfNeeded() {
  try {
    const status = await onboardingService.getStatus();
    if (!status.auto_show_checklist) return;

    openOnboardingChecklist();
  } catch {
    // Non-blocking
  }
}
